// type
import { Category2 } from 'iconsax-react';

// icons
const icons = {
  navigation: Category2,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  // title: 'Navigation',
  icon: icons.navigation,
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.navigation,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
